import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

window.Swiper = function (container, parameters) {
  parameters.loop = false;
  parameters.rewind = true;
  parameters.keyboard = true;

  return new Swiper(container, parameters);
};
